<template>
  <div class="d-justifycontent-center">
    <img 
    :src="imageSrc" 
    alt="Ehh?"
  />
  </div>
  
</template>

<script>
import imageSrc from '@/assets/haha.jpg';

export default {
  data() {
    return {
      imageSrc
    }
  }
}
</script>